import Swal from 'sweetalert2'

const CloudError = {
    error: (error) => {
      if(error.response){
        switch (error.response.status) {
            case 422:
            let errors = Object.keys(error.response.data.errors);
            var footerText = "";
            Array.from(errors).forEach((err) => {
              footerText += error.response.data.errors[err];
            });
            Swal.fire({
              title: "Ups!",
              text: "Los datos enviados son invalidos",
              icon: 'error',
              footer: footerText
            });
          break;
          case 204:
            // Do nothing
            console.log("processing...");
          break;
          case 401:
            Swal.fire({
              title: "Ups!",
              text: "No cuenta con autorización para ingresar",
              icon: 'error',
            });
          break;
          default:
            Swal.fire({
              title: "Ups!",
              text: "Lo sentimos, algo salió mal",
              icon: 'error',
            });
            console.log(error);
          break;
        }
      }else{
        Swal.fire({
          title: "Ups!",
          text: "Lo sentimos, algo salió mal",
          icon: 'error',
        });
      }
    }
}

export default CloudError;